import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';

import { getAssetSrc } from '@restworld/utils-common';

import { mapDefaultArgsType } from './job-location-map.mocks';
import { Button } from '../../';

export type IMapProps = mapDefaultArgsType;

// The map and its geometry (maplibre, turf) load in their own chunk instead of with every page
// that imports this library through its barrel (RW-235, item 4). The component already waits
// for the map to scroll near the viewport before drawing it, so the extra chunk costs nothing
// visible; while it loads, the box keeps its size.
export const MapComponent = dynamic<IMapProps>(() => import('./job-location-map').then((mod) => mod.MapComponent), {
  loading: () => <div className="h-96 w-full mb-[36px] relative" />,
});
export default MapComponent;

export const ImageLoadPlaceholder = ({ mapViewToggler }: { mapViewToggler: () => void }) => {
  const { t } = useTranslation('common');
  return (
    <div className="absolute w-full h-full z-[8]">
      <div className="relative w-full h-full inline-block">
        <img
          src={getAssetSrc('/utils-assets/map-placeholder-image.png')}
          className="w-full h-full object-cover"
          alt=""
        />
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <Button title={t('view_location_on_map')} variant="secondary-outline" onClick={mapViewToggler} />
        </span>
      </div>
    </div>
  );
};
export * from './job-location-map.mocks';
